// US_06 — Báo cáo cá nhân (Gương Thần): shared constants.

/** Base routes for the Gương Thần reports (CR10 — 3 tabs). */
export const MAGIC_MIRROR_ROUTE = {
  /** Tab "Kết quả của tôi" / employee self-view. */
  PERSONAL: "/magic-mirror",
  /** Tab "Kết quả nhân viên" (manager → 1 employee). */
  EMPLOYEE: "/magic-mirror/employee", // + /:userId
  /** Tab "Tổng quan đơn vị" (US_05 — Phase 3, not built in Phase 2). */
  WORKSPACE: "/magic-mirror/unit",
};

export const buildEmployeeReportPath = (userId: number | string) =>
  `${MAGIC_MIRROR_ROUTE.EMPLOYEE}/${userId}`;

/** Tab keys (CR10). */
export const REPORT_TAB = {
  PERSONAL: "personal",
  WORKSPACE: "workspace",
  EMPLOYEE: "employee",
} as const;

export type ReportTabKey = (typeof REPORT_TAB)[keyof typeof REPORT_TAB];

/** Quick-search activates from ≥ 3 characters (§4.8.1 / §2.5). */
export const SEARCH_MIN_CHARS = 3;
export const SEARCH_DEBOUNCE_MS = 350;

/** Feedback list page size: hiển thị 3 item, mỗi lần "Xem thêm" lấy thêm 3. */
export const FEEDBACK_PER_PAGE = 3;

/** Behavior progress-bar thresholds & colors (§4.8.5). */
export const BEHAVIOR_SCORE_THRESHOLD = {
  GOOD: 70, // 70–100 → green
  MEDIUM: 40, // 40–69 → yellow ; < 40 → red
};

export const BEHAVIOR_BAR_COLOR = {
  GOOD: "#22c55e", // xanh lá (Figma)
  MEDIUM: "#f2c94c", // vàng (Figma)
  LOW: "#d97706", // cam/đỏ (Figma)
};

/**
 * Trend chart series colors (§4.8.4 — Figma).
 * Lưu ý: dùng cho chart.js (canvas) nên phải là giá trị màu cụ thể — KHÔNG dùng được
 * `var(--primary-color)` ở đây (canvas không resolve CSS var). PERSONAL = primary #f0b71c.
 */
export const TREND_COLOR = {
  PERSONAL: "#f0b71c", // CÁ NHÂN — vàng, nét liền (= --primary-color)
  COMPANY: "#d6d3d1", // TRUNG BÌNH CÔNG TY — xám, nét đứt
};

/** Trend/delta direction → display color (Figma: success #16a34a / cam #d97706 / xám #a8a29e). */
export const TREND_DIRECTION_COLOR = {
  up: "#16a34a",
  down: "#d97706",
  flat: "#a8a29e",
};

/** Màu nhãn "Top x%" của thẻ G-Gene (Accent Success — Figma #47c751). */
export const G_GENE_RANK_LABEL_COLOR = "#47c751";

/** Màu số điểm G-Gene theo tier percentile toàn quốc (§2.1 `g_gene.color`). */
export const G_GENE_COLOR = {
  green: "#41AC49",
  yellow: "#F0B71C",
  red: "#D94D27",
} as const;
